<template>
  <Popover
    placement="bottom-start"
    :show-arrow="false"
    same-width
    :offset-x="-10"
    :same-width-pad="20"
    :trigger="(disabled || readonly) ? 'manual' : 'click'"
    v-bind="$attrs"
  >
    <NewBsBox
      :bs="{
        display: 'flex',
        height: '100%',
        cursor: (disabled || readonly) ? 'inherit' : 'pointer',
        alignItems: 'center',
        ...bs,
      }"
    >
      <div>{{ currentUit }}</div>
      <BeerIcon
        v-if="unitEnums.length > 0 && !readonly"
        :size="14"
        :bs="{ ml: 8 }"
        icon="arrow-down-m"
        color="mute"
      />
    </NewBsBox>
    <template
      v-if="unitEnums.length > 0"
      #popover="{ toggle }"
    >
      <Option
        v-for="op of unitEnums"
        :key="op"
        :data-active="op === currentUit || null"
        @click="() => selectUnit(op, toggle)"
      >
        {{ op }}
      </Option>
    </template>
  </Popover>
</template>

<script lang="ts">
  import {
    defineComponent, PropType,
  } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import Popover from '@xhs/yam-beer/cmp/overlayers/Popover/Popover.vue'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import Option from '@xhs/yam-beer/cmp/overlayers/Option/Option.vue'
  import { BeerStyleObj } from '../../../core'

  export default defineComponent({
    name: 'UnitCell',
    components: {
      NewBsBox,
      BeerIcon,
      Popover,
      Option,
    },
    props: {
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      currentUit: [Number, String],
      onSelectUnit: {
        type: Function,
        required: true,
      },
      /**
       * @ignore
       * 是否只读显示
       */
      readonly: {
        type: Boolean,
        default: false,
      },
      unitEnums: {
        type: Array,
        default: () => ([]),
      },
      /**
       * 是否禁止
       */
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      selectUnit(op: unknown, toggle: (flag: boolean) => void) {
        this.onSelectUnit?.(op)
        toggle(false)
      },
    },
  })
</script>
